import { LandingPage, MTADeclined } from "@/config/app-constant";

import { FooterHookType } from "./types/footer.type";

function useFooterHook({ id }: FooterHookType) {
  const buttonStyle = {
    default: `${
      id === "cover-type" && "lg:max-w-[342px]"
    } w-full rounded-radius-pill px-spacing-l
        py-spacing-s font-body-font text-text-on-primary font-semibold leading-[18px] h-spacing-xxxl
        bg-interactive-primary-default-1 border-interactive-primary-default-1 hover:bg-interactive-primary-hovered
        hover:border-interactive-primary-hovered active:bg-interactive-primary-pressed-2 active:border-interactive-primary-pressed-2
         text-xs relative z-[2] md:w-[244px] landscape:w-[604px]`,
    disable: `bg-interactive-primary-default-1 border-interactive-primary-default-1
        hover:bg-interactive-primary-hovered hover:border-interactive-primary-hovered text-text-on-primary 
           border-[1.5px] active:bg-interactive-primary-pressed-2 
         active:border-interactive-primary-pressed-2 flex flex-col justify-center items-center 
          ${
            id === "cover-type" && "lg:max-w-[342px]"
          } w-full rounded-radius-pill 
        px-spacing-l py-spacing-s disabled:bg-surface-neutral-option-5 disabled:border-surface-neutral-option-5 
        disabled:text-text-disabled font-body-font
         text-xs leading-[18px] font-semibold h-[56px]  relative z-[2] md:w-[244px] landscape:w-[604px]`,
  };

  function getButtonStyle(usage: string, disable: boolean) {
    let key: "default" | "disable" = "default";
    if (usage !== LandingPage && disable) {
      key = "disable";
    }

    if (id === MTADeclined) {
      return ` ${buttonStyle[key]} md:w-[342px]`;
    }

    return buttonStyle[key];
  }

  return { getButtonStyle };
}

export default useFooterHook;
